import React from 'react';
import { StarIcon, BadgeCheckIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { SectionCta } from './SectionCta';
import { testimonials } from '../data/content';
export function TestimonialsSection() {
  return <section className="w-full bg-ink py-16 sm:py-24" aria-label="Testimonials" data-id="element-286" data-mp="1mxy19jyqraqy">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-287" data-mp="1r02syd5mpxay">
        <SectionHeading title={<>
              What technicians are <span className="text-volt" data-id="element-289" data-mp="1i0xut7xzc5zb">saying</span>
            </>} sub="Shops using the pathway on real battery drain jobs." data-id="element-288" data-mp="1d1bhkyi5ipqi" />

        <div className="mt-12 grid gap-5 lg:grid-cols-3" data-id="element-290" data-mp="142r54f36pcaq">
          {testimonials.map(t => <figure key={t.name} className="flex flex-col rounded-2xl bg-navy p-5 sm:p-6" data-id="element-291" data-mp="1839xca8zokdg">
              <div className="flex items-center gap-4" data-id="element-292" data-mp="2ygildxg0quf5">
                <img src={t.image} alt={`Portrait of ${t.name}`} className="h-20 w-20 shrink-0 rounded-full object-cover ring-4 ring-volt" loading="lazy" data-id="element-293" data-mp="32gixvcjk4vjk" />
                <div data-id="element-294" data-mp="2q1pxeaodp25y">
                  <figcaption className="flex items-center gap-1.5 text-lg font-bold text-white" data-id="element-295" data-mp="2q0eyop9siklp">
                    {t.name}
                    <BadgeCheckIcon className="h-5 w-5 text-spark" aria-label="Verified buyer" data-id="element-296" data-mp="2zskoptghery9" />
                  </figcaption>
                  <p className="text-sm text-mist" data-id="element-297" data-mp="2c3ro3jowzvxb">{t.role}</p>
                  <div className="mt-1 flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-298" data-mp="273n77sk3gz6k">
                    {[0, 1, 2, 3, 4].map(s => <StarIcon key={s} className="h-4 w-4 fill-volt text-volt" aria-hidden="true" data-id="element-299" data-mp="2m1xo1vr5urzj" />)}
                  </div>
                </div>
              </div>
              <blockquote className="mt-5 text-base leading-relaxed text-white" data-id="element-300" data-mp="1a5jz0x4ph36">“{t.quote}”</blockquote>
            </figure>)}
        </div>

        <SectionCta label="Get the same results — $27" data-id="element-301" data-mp="3sj2oollwsd7g" />
      </div>
    </section>;
}